import { render, staticRenderFns } from "./CmgOrderConfirmationCancelOrderModal.vue?vue&type=template&id=a5c1d912&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-cancel-order-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-cancel-order-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationCancelOrderModal.vue?vue&type=style&index=0&id=a5c1d912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c1d912",
  null
  
)

export default component.exports